import { combineReducers } from '@reduxjs/toolkit';

import chatNotifications from './chatNotifications';
import commerceConf from './commerceConf';
import inventory from './inventory';
import partners from './partners';

const rootReducer = combineReducers({
  inventory,
  partners,
  commerceConf,
  chatNotifications,
});

export default rootReducer;
